export const carouselItems = [
  {
    id: 'c1',
    title: '热血少年漫专区',
    tag: '热门推荐',
    description: '百部热血战斗漫画免费畅读，从经典到新番一网打尽。每周更新第一时间同步，战斗场面高清画质呈现。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20manga%20style%20illustration%20with%20dynamic%20action%20scene%2C%20warm%20orange%20and%20red%20color%20palette%2C%20Japanese%20comic%20aesthetic%2C%20dramatic%20lighting%2C%20clean%20composition%20on%20soft%20cream%20background%2C%20vibrant%20energetic%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 'c2',
    title: '韩漫精选合集',
    tag: '编辑精选',
    description: '全彩竖屏韩漫持续上新，都市恋爱、奇幻穿越题材丰富。下拉式沉浸阅读体验，全本免费不卡顿。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20illustration%2C%20soft%20pink%20and%20peach%20tones%2C%20modern%20urban%20setting%2C%20clean%20minimalist%20composition%2C%20gentle%20atmospheric%20lighting%2C%20warm%20cream%20background%2C%20elegant%20character%20design&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 'c3',
    title: '每日更新追踪',
    tag: '连载速递',
    description: '日更漫画追更提醒，热门连载最新章节第一时间推送。漫画全集随心收藏，新番上线不再错过。',
    image: 'https://readdy.ai/api/search-image?query=Manga%20reading%20on%20digital%20tablet%20with%20cozy%20atmosphere%2C%20warm%20amber%20lighting%2C%20Japanese%20manga%20pages%20visible%20on%20screen%2C%20tea%20cup%20nearby%2C%20soft%20cream%20white%20background%2C%20relaxed%20reading%20vibe%2C%20clean%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 'c4',
    title: '国漫崛起计划',
    tag: '原创精品',
    description: '支持国产原创漫画，古风仙侠、现代都市题材全覆盖。精美画风搭配精彩剧情，免费漫画畅享阅读。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20fantasy%20illustration%20with%20ancient%20Chinese%20architecture%2C%20flowing%20ink%20wash%20painting%20aesthetic%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20ethereal%20atmosphere%2C%20soft%20cream%20background%2C%20elegant%20traditional%20elements&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export const commentsItems = [
  {
    id: 'cm1',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20style%20cute%20avatar%20icon%2C%20warm%20peach%20background%2C%20simple%20character%20face%2C%20clean%20design%2C%20soft%20round%20shape&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '星空下的读者',
    time: '2小时前',
    content: '爱漫画网真的是我用过最舒服的在线看漫画平台了！页面干净没有乱七八糟的弹窗广告，下拉式阅读体验超级流畅，晚上躺床上刷韩漫太爽了。',
    work: '《霸道总裁的契约新娘》',
  },
  {
    id: 'cm2',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20style%20cute%20avatar%20icon%2C%20warm%20amber%20background%2C%20simple%20character%20face%2C%20clean%20design%2C%20soft%20round%20shape&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '漫画追更人',
    time: '5小时前',
    content: '日漫更新速度真的快！每周三晚上就蹲着刷新等最新一话，比某些平台快了一整天。国漫专区也越来越丰富了，推荐《斗破苍穹》画风超赞！',
    work: '《斗破苍穹》',
  },
  {
    id: 'cm3',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20style%20cute%20avatar%20icon%2C%20warm%20coral%20background%2C%20simple%20character%20face%2C%20clean%20design%2C%20soft%20round%20shape&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜读书人',
    time: '昨天',
    content: '手机版适配做得太好了，上下班地铁上追漫毫无压力。收藏功能很方便，追更列表一目了然。已推荐给身边所有爱看漫画的朋友！',
    work: '《重生之都市修仙》',
  },
];

export const rankingItems = [
  { id: 'r1', rank: 1, title: '斗破苍穹', tag: '热血', heat: '9.8', status: '连载中', change: 'up' },
  { id: 'r2', rank: 2, title: '霸道总裁的契约新娘', tag: '恋爱', heat: '9.7', status: '连载中', change: 'up' },
  { id: 'r3', rank: 3, title: '重生之都市修仙', tag: '玄幻', heat: '9.6', status: '连载中', change: 'same' },
  { id: 'r4', rank: 4, title: '一人之下', tag: '国漫', heat: '9.5', status: '连载中', change: 'up' },
  { id: 'r5', rank: 5, title: '某天成为公主', tag: '韩漫', heat: '9.4', status: '已完结', change: 'down' },
];

export const updatesItems = [
  { id: 'u1', time: '10分钟前', title: '《斗破苍穹》第452话', desc: '萧炎突破斗尊境界，大战一触即发' },
  { id: 'u2', time: '28分钟前', title: '《霸道总裁的契约新娘》第89话', desc: '真相即将揭晓，她的身份竟然是…' },
  { id: 'u3', time: '1小时前', title: '《重生之都市修仙》第213话', desc: '陈凡重返都市，昔日仇敌尽数伏诛' },
  { id: 'u4', time: '2小时前', title: '《一人之下》第617话', desc: '张楚岚闯入唐门禁地，异人世界再掀波澜' },
  { id: 'u5', time: '3小时前', title: '《剑来》第318话', desc: '陈平安一剑破万法，剑气纵横三万里' },
  { id: 'u6', time: '4小时前', title: '《全职高手》第286话', desc: '叶修率兴欣战队冲击季后赛' },
  { id: 'u7', time: '5小时前', title: '《狐妖小红娘》第521话', desc: '涂山苏苏前世记忆苏醒，千年情缘再续' },
  { id: 'u8', time: '6小时前', title: '《镖人》第138话', desc: '刀马深入西域大漠，一场生死搏杀' },
  { id: 'u9', time: '8小时前', title: '《镇魂街》第373话', desc: '曹焱兵解锁第七守护灵，终极对决开启' },
];

export const aboutContent = {
  title: '关于爱漫画网',
  paragraphs: [
    '爱漫画网创建于2019年，是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供海量正版漫画资源与极致的阅读体验。我们汇聚了韩漫、日漫、国漫等多元题材，覆盖恋爱、热血、玄幻、悬疑、日常等全品类内容，满足不同读者的口味偏好。',
    '平台采用先进的下拉式沉浸阅读技术，支持手机版、电脑版无缝切换，让读者随时随地畅享高清漫画阅读。我们与国内外多家漫画工作室及出版社建立了深度合作关系，确保内容持续更新，每日都有最新话上架。',
    '爱漫画网始终坚持免费阅读的初心，为漫画爱好者打造一个纯净、便捷、内容丰富的在线漫画家园。从热门连载到经典全集，从新番速递到独家推荐，每位读者都能在这里找到属于自己的漫画世界。',
  ],
};

export const faqItems = [
  {
    id: 'f1',
    q: '爱漫画网的漫画都是免费的吗？',
    a: '是的，爱漫画网所有漫画资源均免费向读者开放。您无需付费即可畅读全站漫画，包括热门连载、经典全集和最新番剧。我们通过广告合作维持平台运营，确保读者始终享受免费阅读服务。',
  },
  {
    id: 'f2',
    q: '如何在手机上访问爱漫画网？',
    a: '爱漫画网已针对手机版进行全面适配优化。您可以直接在手机浏览器中输入爱漫画网官网地址访问，也可以将网站添加到手机桌面，像使用 App 一样快捷打开。下拉式阅读模式在手机上体验尤其流畅。',
  },
  {
    id: 'f3',
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常保持每日或每周固定更新。我们会第一时间同步国内外各大漫画平台的最新话，确保读者不会错过任何精彩内容。更新动态可以在首页"最近更新"模块实时查看。',
  },
  {
    id: 'f4',
    q: '支持哪些类型的漫画？',
    a: '爱漫画网涵盖韩漫、日漫、国漫三大主要类别，题材包括恋爱、热血、玄幻、悬疑、搞笑、日常、奇幻、古风等。无论您喜欢哪种风格，都能在这里找到心仪的作品。',
  },
  {
    id: 'f5',
    q: '需要注册账号才能看漫画吗？',
    a: '不需要。爱漫画网支持免注册直接阅读，打开即可开始看漫画。如果您希望使用收藏、追更提醒等个性化功能，可以选择注册账号，但阅读本身完全不需要登录。',
  },
  {
    id: 'f6',
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的分类索引、热门排行、话题标签等方式浏览漫画，也可以使用搜索功能直接查找作品名称。首页的专题推荐和编辑精选也能帮助您发现优质漫画。',
  },
];

export const mediaItems = [
  {
    id: 'm1',
    title: '韩漫精选：都市恋爱特辑',
    tag: '韩漫',
    desc: '二十部高分韩漫推荐，从甜蜜到虐心全收录',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20illustration%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20tones%2C%20young%20couple%20in%20modern%20Seoul%20street%2C%20gentle%20atmospheric%20lighting%2C%20clean%20minimal%20composition%2C%20warm%20romantic%20mood&width=700&height=400&seq=media-01&orientation=landscape',
  },
  {
    id: 'm2',
    title: '日漫经典：热血战斗名场面',
    tag: '日漫',
    desc: '盘点日漫史上最燃的十大战斗名场面',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20epic%20battle%20scene%2C%20dynamic%20action%20composition%2C%20warm%20orange%20and%20amber%20energy%20effects%2C%20dramatic%20lighting%2C%20clean%20background%20with%20soft%20gradient%2C%20powerful%20atmosphere&width=700&height=400&seq=media-02&orientation=landscape',
  },
  {
    id: 'm3',
    title: '国漫崛起：古风仙侠画卷',
    tag: '国漫',
    desc: '精选十部画风绝美的国产古风漫画推荐',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20ink%20wash%20painting%20style%2C%20ancient%20Chinese%20fantasy%20landscape%20with%20mountains%20and%20clouds%2C%20jade%20green%20and%20golden%20tones%2C%20ethereal%20atmosphere%2C%20elegant%20composition%2C%20soft%20cream%20background&width=700&height=400&seq=media-03&orientation=landscape',
  },
  {
    id: 'm4',
    title: '新番速递：本月必追连载',
    tag: '新番',
    desc: '七月新番上线指南，最值得追的连载都在这里',
    image: 'https://readdy.ai/api/search-image?query=Manga%20magazine%20cover%20style%20collage%2C%20various%20manga%20panels%20arranged%20artistically%2C%20warm%20vibrant%20color%20palette%2C%20clean%20cream%20background%2C%20modern%20editorial%20design%2C%20eye-catching%20composition&width=700&height=400&seq=media-04&orientation=landscape',
  },
];

export const appContent = {
  title: '随时随地，畅享漫画阅读',
  subtitle: '爱漫画网手机版已全面适配，无需下载 App，浏览器打开即可享受原生应用般的流畅阅读体验',
  features: ['下拉式沉浸阅读', '高清画质不压缩', '追更收藏一键搞定', '免注册直接畅读'],
};

export const indexItems = [
  { id: 'i1', title: '恋爱漫画', icon: 'ri-heart-line', count: '2,386部', color: 'bg-accent-100 text-accent-700' },
  { id: 'i2', title: '热血漫画', icon: 'ri-fire-line', count: '1,954部', color: 'bg-primary-100 text-primary-700' },
  { id: 'i3', title: '玄幻漫画', icon: 'ri-magic-line', count: '1,723部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 'i4', title: '悬疑漫画', icon: 'ri-search-eye-line', count: '892部', color: 'bg-accent-100 text-accent-700' },
  { id: 'i5', title: '搞笑漫画', icon: 'ri-emotion-laugh-line', count: '1,456部', color: 'bg-primary-100 text-primary-700' },
  { id: 'i6', title: '古风漫画', icon: 'ri-article-line', count: '634部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 'i7', title: '奇幻漫画', icon: 'ri-moon-line', count: '1,102部', color: 'bg-accent-100 text-accent-700' },
  { id: 'i8', title: '日常漫画', icon: 'ri-home-line', count: '978部', color: 'bg-primary-100 text-primary-700' },
];

export const contactContent = {
  title: '联系我们',
  desc: '如果您有漫画投稿、商务合作或任何建议，欢迎通过以下方式联系爱漫画网团队。我们会在24小时内回复您的消息。',
  email: 'contact@aimanhua.com',
  qq: '1234567890',
  wechat: 'aimanhua_official',
};

export const topicsItems = [
  { id: 't1', name: '韩漫推荐', heat: '9.8万讨论' },
  { id: 't2', name: '日漫更新', heat: '8.5万讨论' },
  { id: 't3', name: '国漫原创', heat: '7.2万讨论' },
  { id: 't4', name: '恋爱漫画', heat: '6.9万讨论' },
  { id: 't5', name: '热血战斗', heat: '6.3万讨论' },
  { id: 't6', name: '下拉式阅读', heat: '5.8万讨论' },
  { id: 't7', name: '免费漫画', heat: '5.2万讨论' },
  { id: 't8', name: '漫画全集', heat: '4.7万讨论' },
  { id: 't9', name: '新番速递', heat: '4.1万讨论' },
  { id: 't10', name: '漫画追更', heat: '3.6万讨论' },
];

export const cardsItems = [
  {
    id: 'cd1',
    title: '韩漫专区',
    tag: '全彩竖屏',
    desc: '精选百部高分韩漫，都市恋爱、奇幻穿越题材全覆盖，全彩竖屏下拉式阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20soft%20romantic%20atmosphere%2C%20peach%20and%20cream%20color%20palette%2C%20modern%20urban%20Seoul%20cityscape%20background%2C%20elegant%20character%20silhouette%2C%20clean%20minimal%20composition&width=800&height=560&seq=card-01&orientation=landscape',
  },
  {
    id: 'cd2',
    title: '日漫经典',
    tag: '热血少年',
    desc: '从Jump经典到新世代佳作，热血、悬疑、搞笑全收录，日更同步不落后。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20illustration%2C%20dynamic%20composition%20with%20energy%20lines%2C%20warm%20orange%20and%20red%20accents%2C%20clean%20cream%20background%2C%20dramatic%20lighting%2C%20powerful%20atmosphere&width=800&height=560&seq=card-02&orientation=landscape',
  },
  {
    id: 'cd3',
    title: '国漫原创',
    tag: '古风仙侠',
    desc: '支持国产原创漫画，古风、玄幻、都市题材精品不断，画风精美剧情诱人。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20ink%20style%20fantasy%20illustration%2C%20ancient%20Chinese%20architecture%20with%20flowing%20ribbons%2C%20jade%20green%20and%20warm%20golden%20tones%2C%20ethereal%20clouds%2C%20elegant%20traditional%20aesthetic&width=800&height=560&seq=card-03&orientation=landscape',
  },
  {
    id: 'cd4',
    title: '每日追更',
    tag: '实时同步',
    desc: '热门连载每日更新提醒，最新章节第一时间推送。追更列表一目了然，永不掉队。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20manga%20pages%20with%20notification%20bubbles%2C%20cozy%20reading%20nook%20atmosphere%2C%20warm%20amber%20lighting%2C%20clean%20cream%20background%2C%20modern%20tech%20lifestyle%2C%20relaxed%20mood&width=800&height=560&seq=card-04&orientation=landscape',
  },
  {
    id: 'cd5',
    title: '漫画全集',
    tag: '一次看够',
    desc: '已完结漫画全集收录，一口气从第一话看到大结局。经典神作永久保存，随时重温。',
    image: 'https://readdy.ai/api/search-image?query=Manga%20bookshelf%20with%20colorful%20comic%20volumes%20arranged%20neatly%2C%20warm%20cozy%20library%20atmosphere%2C%20soft%20natural%20light%2C%20cream%20and%20wood%20tones%2C%20organized%20collection%2C%20inviting%20reading%20space&width=800&height=560&seq=card-05&orientation=landscape',
  },
];

export const featuresItems = [
  {
    id: 'fe1',
    title: '海量漫画资源',
    desc: '收录超过两万部韩漫、日漫、国漫，题材覆盖恋爱、热血、玄幻、悬疑等全品类，免费漫画随心畅读。',
    icon: 'ri-stack-line',
  },
  {
    id: 'fe2',
    title: '下拉式沉浸阅读',
    desc: '创新的竖屏下拉阅读模式，无需翻页即可连续阅读。高清画质、流畅加载，手机版体验尤其出色。',
    icon: 'ri-book-open-line',
  },
  {
    id: 'fe3',
    title: '每日同步更新',
    desc: '与国内外漫画平台保持同步，热门连载每日更新。追更列表实时提醒，爱漫画网让你永不掉队。',
    icon: 'ri-refresh-line',
  },
  {
    id: 'fe4',
    title: '免注册畅读',
    desc: '无需注册登录即可直接阅读所有漫画。无广告弹窗干扰，纯净阅读环境，打开爱漫画网首页即看。',
    icon: 'ri-user-smile-line',
  },
  {
    id: 'fe5',
    title: '全平台适配',
    desc: '爱漫画网手机版、电脑版全适配，浏览器打开即可使用。支持收藏同步，换设备继续追更。',
    icon: 'ri-device-line',
  },
];